//Validar que solo acepte texto
export const regexName = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
//Validar que solo acepte email
export const regexEmail = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/;
//Validar que solo acepte nuemros
export const regexNumber = /^[1-9]\d*(\.\d+)?$/;
//Validar que solo acepte nuemros
export const regexMontoNumber = /^[1-9]([0-9]{1,2})?([.][0-9]{2})?$/;